import * as yup from 'yup';
import { useFormHandler } from './useFormHandler';

export type FaqByCategoryFormValues = {
  name: string;
};

export type FaqFormValues = {
  category: string;
  answer: string;
  question: string;
  isPublished: boolean;
};

export const faqByCategoryValidationSchema = yup.object({
  name: yup.string().required('Le nom est obligatoire'),
});

export const faqValidationSchema = yup.object({
  category: yup.string().required('La catégorie est obligatoire'),
  answer: yup.string().required('La réponse est obligatoire'),
  question: yup.string().required('La question est obligatoire'),
  isPublished: yup.boolean().default(false),
});

export const useFaqByCategoryForm = () => {
  const {
    handleSubmit: handleSubmitFaqByCategory,
    register: registerFaqByCategory,
    errors: errorsFaqByCategory,
    reset: resetFaqByCategory,
  } = useFormHandler<FaqByCategoryFormValues>(faqByCategoryValidationSchema);

  const {
    handleSubmit: handleSubmitFaq,
    register: registerFaq,
    errors: errorsFaq,
    reset: resetFaq,
    setValue: setValueFaq,
    control,
  } = useFormHandler<FaqFormValues>(faqValidationSchema);

  return {
    handleSubmitFaqByCategory,
    registerFaqByCategory,
    errorsFaqByCategory,
    resetFaqByCategory,
    handleSubmitFaq,
    registerFaq,
    errorsFaq,
    resetFaq,
    setValueFaq,
    control,
  };
};
